import { Component, inject, Input, OnDestroy } from '@angular/core';
import { DismissedPopupKeywords } from '@isophi/core-legacy';

import { PopupService } from '../../../../shared/services/popup.service';

@Component({
  selector: 'app-management-popup',
  templateUrl: './management-popup.component.html',
  styleUrls: ['./management-popup.component.scss'],
  standalone: false,
})
export class ManagementPopupComponent implements OnDestroy {
  private readonly popupService = inject(PopupService);

  @Input() popupKey: DismissedPopupKeywords;

  dontShowAgain = false;

  close(): void {
    this.popupService.closePopup(this.popupKey);
  }

  ngOnDestroy(): void {
    if (this.dontShowAgain) {
      this.popupService.dismissPopup(this.popupKey);
    }
    this.popupService.closePopup(this.popupKey, true);
  }
}
